import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 1H3c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM3 2h13c.551 0 1 .449 1 1v1H2V3c0-.551.449-1 1-1zm13 17H3c-.551 0-1-.449-1-1V5h15v13c0 .551-.449 1-1 1z',
    'M4.5 15h2c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5zm.5-3h1v2H5v-2zM8.5 15h2c.276 0 .5-.224.5-.5v-5c0-.276-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5v5c0 .276.224.5.5.5zm.5-5h1v4H9v-4zM14.5 7h-2c-.276 0-.5.224-.5.5v7c0 .276.224.5.5.5h2c.276 0 .5-.224.5-.5v-7c0-.276-.224-.5-.5-.5zm-.5 7h-1V8h1v6zM4 16h11v1H4v-1z',
  ],
  height: 20,
  width: 20,
});
